const STORAGE_KEY = 'investments-menu-expanded';

export function getStoredExpansionState(): boolean {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'true';
  } catch {
    return false;
  }
}

export function toggleExpansionState(current: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(!current));
  } catch {
    // ignore storage errors
  }
}
